import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const financeAccountTypeListWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.account-type-list",
  name: "Balance by account type",
  description: "Balance by account type as a compact RQL list.",
  apps: [
    "home",
    "finance",
  ],
  template: "list",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "finance.journal-items",
      ...period(30),
      select: [
        {
          type: "field",
          field: "account_type",
          as: "account_type",
        },
        {
          type: "aggregate",
          function: "sum",
          field: "balance",
          as: "balance",
        },
      ],
      group_by: [
        {
          field: "account_type",
        },
      ],
      order_by: [
        {
          ref: "balance",
          direction: "desc",
        },
      ],
      limit: 20,
    },
  },
  inputs: {
    title: "Balance by account type",
    columns: [
      {
        key: "account_type",
        label: "Account type",
      },
      {
        key: "balance",
        label: "Balance",
        align: "end",
        format: "currency",
      },
    ],
    maxRows: 20,
    showAccountTypeDescription: true,
  },
  dummyData: {
    rows: [
      {
        account_type: "Income",
        balance: 82900,
      },
      {
        account_type: "Expense",
        balance: -68500,
      },
      {
        account_type: "Asset",
        balance: 42100,
      },
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
